import { ControlGroupLockedEmptyState } from "@src/features/experienceBuilder/modifications/emptyState/ControlGroupLockedEmptyState";
import { ModificationsNavigateEmptyState } from "@src/features/experienceBuilder/modifications/emptyState/ModificationsNavigateEmptyState";
import { ModificationsSelectEmptyState } from "@src/features/experienceBuilder/modifications/emptyState/ModificationsSelectEmptyState";
import { ModificationsWillAppearEmptyState } from "@src/features/experienceBuilder/modifications/emptyState/ModificationsWillAppearEmptyState";
import { useSelector } from "@src/store";
import { ExperienceBuilderSelector } from "@src/store/slices/experienceBuilder";

export const ModificationEmptyState = () => {
  const lockStatus = useSelector(
    ExperienceBuilderSelector.getModificationsLockStatus
  );
  const mode = useSelector(ExperienceBuilderSelector.getMode);
  const isOnsiteUpsell = useSelector(
    ExperienceBuilderSelector.isOnsiteUpsellBuilder
  );
  if (lockStatus === "locked") {
    return <ControlGroupLockedEmptyState />;
  }
  // Upsells aren't authored by navigating + selecting page elements, so skip
  // those prompts and show the passive "will appear here" state instead.
  if (isOnsiteUpsell) {
    return <ModificationsWillAppearEmptyState />;
  }
  if (mode === "select") {
    return <ModificationsSelectEmptyState />;
  }
  return <ModificationsNavigateEmptyState />;
};
